import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { PayPalScriptProvider } from "@paypal/react-paypal-js";
import { Toaster } from "@/components/ui/sonner";
import { SmoothScroll } from "@/components/SmoothScroll";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";

const paypalOptions = {
  "client-id": process.env.REACT_APP_PAYPAL_CLIENT_ID,
  currency: "USD",
  intent: "capture",
};

function App() {
  return (
    <div className="App">
      <PayPalScriptProvider options={paypalOptions}>
        <SmoothScroll />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </BrowserRouter>
      </PayPalScriptProvider>
      <Toaster theme="dark" position="top-center" />
    </div>
  );
}

export default App;
